import React from "react";
import { Box, Button, FormHelperText, Grid } from "@mui/material";
import Upload from "@mui/icons-material/Upload";

const FileUploadComponent = ({ type, name, fileUrl, handleFileChange, setFileUrl, setFile, isMedia, error, helperText }) => {
  return (
    <Box display="flex" alignItems="start" justifyContent="flex-start" minHeight="100px">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} pl={0} sx={{ width: "150px !important", maxWidth: "210px !important" }}>
          <Grid item xs={12}>
            <label htmlFor={`upload-${type}`}>
              <input
                accept={isMedia ? (type === "video" ? "video/*" : "audio/*") : "image/*"}
                style={{ display: "none" }}
                id={`upload-${type}`}
                type="file"
                onChange={(e) => {
                  handleFileChange(e);
                  e.target.value = null; // Reset the value of the input element.
                }}
              />
              <Button variant="contained" color="primary" component="span" startIcon={<Upload />}>
                Upload {isMedia ? (type === "video" ? "Video" : "Podcast") : name}
              </Button>
            </label>
          </Grid>
          {/* Hata mesajı, sadece kullanıcı dosya yüklemeye çalıştığında gösterilecek */}
          {error && !fileUrl && (
            <FormHelperText error>{helperText}</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={7} pl={0}>
          {/* Medya veya resim önizleme alanı */}
          {fileUrl && (
            <Box position="relative" display="inline-block">
              {isMedia ? (
                type === "video" ? (
                  <video
                    controls
                    src={fileUrl}
                    style={{ maxWidth: "200px", maxHeight: "100px", marginLeft: "10px" }}
                  />
                ) : (
                  <audio
                    controls
                    src={fileUrl}
                    style={{ maxWidth: "300px", maxHeight: "100px", marginLeft: "10px" }}
                  />
                )
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: "8px", border: "1px solid #ccc" }} />
                </Box>
              )}
              <Button
                onClick={() => {
                  setFileUrl(null);
                  setFile(null);
                }}
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  backgroundColor: "rgba(50, 50, 50, 0.7)",
                  borderRadius: "50%",
                  minWidth: "24px",
                  minHeight: "24px",
                  padding: "0",
                  fontSize: "11px",
                  color: "white"
                }}
              >
                X
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FileUploadComponent;
